import { useState, useEffect } from 'react'

import { remoteConfig } from 'utils/firebase'
import { fetchAndActivate, getValue } from 'firebase/remote-config'

export const useFirebaseRemoteConfig = (configKeys) => {
  const [data, setData] = useState({})

  useEffect(() => {
    const fetchRemoteConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig)
        const fetchedValues = configKeys.reduce((acc, { key, type }) => {
          let value
          switch (type) {
            case 'string':
              value = getValue(remoteConfig, key).asString()
              break
            case 'number':
              value = getValue(remoteConfig, key).asNumber()
              break
            case 'boolean':
              value = getValue(remoteConfig, key).asBoolean()
              break
            default:
              value = getValue(remoteConfig, key).asString()
          }
          acc[key] = value

          return acc
        }, {})

        setData(fetchedValues)
      } catch (error) {
        console.log('Failed to fetch remote config', error)
      }
    }

    fetchRemoteConfig()
  }, [])

  return { data }
}
